function hexToRgb(hex: string): [number, number, number] {
	const cleaned = hex.replace('#', '')
	if (cleaned.length !== 6) return [0, 0, 0]
	const num = Number.parseInt(cleaned, 16)
	return [(num >> 16) & 0xff, (num >> 8) & 0xff, num & 0xff]
}

function relativeLuminance(rgb: [number, number, number]): number {
	const [r, g, b] = rgb.map((c) => {
		const v = c / 255
		return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
	}) as [number, number, number]
	return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

export function readableTextColor(hex: string): '#000000' | '#ffffff' {
	return relativeLuminance(hexToRgb(hex)) > 0.55 ? '#000000' : '#ffffff'
}
